export const NOT_PERFORMED = {
  id: 'not_performed',
  label: 'Non eseguita',
};

export const PERFORMED_POSITIVE_CONGENITAL_PATHOLOGIES = {
  id: 'performed_positive_congenital_pathologies',
  label: 'Eseguita, positiva per patologie congenite',
};

export const PERFORMED_NEGATIVE_CONGENITAL_PATHOLOGIES = {
  id: 'performed_negative_congenital_pathologies',
  label: 'Esguita, negativa per patologie congenite',
};

export const UNKNOWN = {
  id: 'unknown',
  label: 'Non noto',
};
